import ComingSoon from '../views/coming-soon.vue'
import dashboard from '../views/dashboard/admin/index.vue'
import operators from '../views/operators/index.vue'
import CooperationRequests from '../views/cooperation/index.vue'
import categories from '../views/categories/index.vue'
import attributes from '../views/attributes/index.vue'
import values from '../views/values/index.vue'
import tags from '../views/tags/index.vue'
import products from '../views/products/index.vue'
import AddProduct from '../views/products/AddProduct.vue'
import ProductDetails from '../views/products/ProductDetails.vue'
import EditProduct from '../views/products/EditProduct.vue'
import faqs from '../views/faqs/index.vue'
import comments from '../views/comments/index.vue'
import users from '../views/users/index.vue'
import userMessages from '../views/users/userMessages.vue'
import messages from '../views/messages/index.vue'
import usersWalletTransactions from '../views/users/usersWalletTransactions.vue'
import sliders from '../views/sliders/index.vue'
import banner from '../views/banners/index.vue'
import stores from '../views/stores/index.vue'
import storeDetails from '../views/stores/storeDetails.vue'
import CreditorDetailsTable from '../views/stores/CreditorDetailsTable.vue'
import StoreProductsSales from '../views/stores/StoreProductsSales.vue'
import SettlementsTable from '../views/stores/SettlementsTable.vue'
import settings from '../views/settings/EditSettings.vue'
import profile from '../views/settings/Profile.vue'
import orders from '../views/orders/index.vue'
import orderDetails from '../views/orders/orderDetails.vue'
import orderDetailsInvoice from '../views/orders/orderDetailsInvoice.vue'
import transactions from '../views/financial/transactions/index.vue'

import occasions from '../views/occasions/index.vue'
import AddOccasion from '../views/occasions/AddOccasion.vue'
import EditOccasion from '../views/occasions/EditOccasion.vue'

import StoreProfile from '../views/seller/StoreProfile.vue'
import MapTest from '../views/seller/map/index.vue'
import StoreDashboard from '../views/dashboard/seller/index.vue'
import StoreProducts from '../views/seller/products/index.vue'
import StoreAddProduct from '../views/seller/products/AddProduct.vue'
import StoreProduct from '../views/seller/products/EditProduct.vue'
import StoreOrders from '../views/seller/StoreOrders.vue'
import UnsettledProductsTable from '../views/seller/UnsettledProductsTable.vue'
import StoreSettlementsTable from '../views/seller/StoreSettlementsTable.vue'




export default [

  {
    path: "/",
    name: "coming-soon",
    component: ComingSoon,
    meta: { title: "به زودی" },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
    meta: {
      title: "پنل مدیریت",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/operators',
    name: 'operators',
    component: operators,
    meta: {
      title: "مدیریت اپراتورها",
      authRequired: true,
      isAdmin: true,
    }
  },
  {
    path: '/dashboard/categories',
    name: 'product.categories',
    component: categories,
    meta: {
      title: "مدیریت دسته بندی محصولات",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/attributes',
    name: 'product.attributes',
    component: attributes,
    meta: {
      title: "مدیریت ویژگی های محصولات",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/values',
    name: 'attribute.values',
    component: values,
    meta: {
      title: "مدیریت مقدار ویژگی ها",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/tags',
    name: 'tags',
    component: tags,
    meta: {
      title: "مدیریت برچسب ها",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/products',
    name: 'product.products',
    component: products,
    meta: {
      title: "مدیریت محصولات",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/products/details/:id',
    name: 'product.details',
    component: ProductDetails,
    meta: {
      title: "جزئیات محصول",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/products/add',
    name: 'product.add',
    component: AddProduct,
    meta: {
      title: "افزودن محصول جدید",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/products/edit/:id',
    name: 'product.edit',
    component: EditProduct,
    props: true,
    meta: {
      title: "ویرایش محصول",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/faqs',
    name: 'faqs',
    component: faqs,
    meta: {
      title: "بخش پرسش و پاسخ محصول",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/comments',
    name: 'comments',
    component: comments,
    meta: {
      title: "بخش نظرات محصول",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/users',
    name: 'users',
    component: users,
    meta: {
      title: "مدیریت کاربران",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/users/messages/:userId',
    name: 'users.messages',
    component: userMessages,
    meta: {
      title: "پیام های کاربر",
      authRequired: true,
      isAdmin: true,
      isOperator: true,
      props: true,
    }
  },
  {
    path: '/dashboard/messages',
    name: 'messages',
    component: messages,
    meta: {
      title: "لیست پیام ها",
      authRequired: true,
      isAdmin: true,
      isOperator: true,
    }
  },
  {
    path: '/dashboard/cooperation-requests',
    name: 'cooperation.requests',
    component: CooperationRequests,
    meta: {
      title: "لیست درخواست های همکاری در فروش",
      authRequired: true,
      isAdmin: true,
      isOperator: true,
    }
  },
  {
    path: '/dashboard/users/wallet/transactions/:userId',
    name: 'users.wallet.transactions',
    component: usersWalletTransactions,
    meta: {
      title: "تراکنش های کیف پول کاربر",
      authRequired: true,
      isAdmin: true,
      props: true,
    }
  },
  {
    path: '/dashboard/sliders',
    name: 'sliders',
    component: sliders,
    meta: {
      title: "مدیریت اسلایدرها",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/ads',
    name: 'ads',
    component: banner,
    meta: {
      title: "مدیریت بنرهای تبلیغاتی",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/stores',
    name: 'stores',
    component: stores,
    meta: {
      title: "مدیریت فروشگاه ها",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/store/details/:id',
    name: 'stores.details',
    component: storeDetails,
    meta: {
      title: "جزئیات فروشگاه",
      authRequired: true,
      isAdmin: true,
      isOperator: true,
      props: true,
    }
  },
  {
    path: '/dashboard/store/products/sales/:storeId',
    name: 'store.products.sales',
    component: StoreProductsSales,
    props: true,
    meta: {
      title: "لیست فروش محصولات",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/store/creditor/details/:storeId',
    name: 'store.creditor.details',
    component: CreditorDetailsTable,
    meta: {
      title: "جزئیات بستانکاری فروشگاه",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/store/settlements/:storeId',
    name: 'store.settlements',
    component: SettlementsTable,
    props: true,
    meta: {
      title: "لیست پرداختی ها به فروشگاه",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/settings',
    name: 'settings',
    component: settings,
    meta: {
      title: "تنظیمات",
      authRequired: true,
      isAdmin: true,
    }
  },
  {
    path: '/dashboard/profile',
    name: 'profile',
    component: profile,
    meta: {
      title: "پروفایل",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/orders',
    name: 'orders',
    component: orders,
    meta: {
      title: "مدیریت سفارشات",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/order/details/:id',
    name: 'orders.details',
    component: orderDetails,
    meta: {
      title: "جزئیات سفارش",
      authRequired: true,
      isAdmin: true,
      isOperator: true,
      props: true,
    }
  },
  {
    path: '/dashboard/order/details/invoice/:id',
    name: 'orders.details.invoice',
    component: orderDetailsInvoice,
    meta: {
      title: "فاکتور جزئیات سفارش",
      authRequired: true,
      isAdmin: true,
      isOperator: true,
      props: true,
    }
  },
  {
    path: '/dashboard/financial/transactions',
    name: 'financial.transactions',
    component: transactions,
    meta: {
      title: "تراکنش ها",
      authRequired: true,
      isAdmin: true,
    }
  },


  /**
   * Reminder Routes
   */
  {
    path: '/dashboard/occasions',
    name: 'occasion.occasions',
    component: occasions,
    meta: {
      title: "مدیریت مناسبت ها",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/occasions/add',
    name: 'occasion.add',
    component: AddOccasion,
    meta: {
      title: "افزودن مناسبت جدید",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },
  {
    path: '/dashboard/occasions/edit/:id',
    name: 'occasion.edit',
    component: EditOccasion,
    props: true,
    meta: {
      title: "ویرایش مناسب",
      authRequired: true,
      isAdmin: true,
      isOperator: true
    }
  },




  /**
   * Seller Routes
   */
  {
    path: '/store/dashboard/profile',
    name: 'store.profile',
    component: StoreProfile,
    meta: {
      title: "پروفایل  فروشگاه",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/dashboard/map',
    name: 'store.map',
    component: MapTest,
    meta: {
      title: "پروفایل  فروشگاه",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/dashboard',
    name: 'store.dashboard',
    component: StoreDashboard,
    meta: {
      title: "پنل مدیریت فروشگاه",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/products',
    name: 'store.product.products',
    component: StoreProducts,
    meta: {
      title: "مدیریت محصولات فروشگاه",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/products/add',
    name: 'store.product.add',
    component: StoreAddProduct,
    meta: {
      title: "افزودن محصول جدید",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/products/edit/:id',
    name: 'store.product.edit',
    component: StoreProduct,
    props: true,
    meta: {
      title: "ویرایش محصول",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/orders',
    name: 'store.orders',
    component: StoreOrders,
    meta: {
      title: "سفارشات فروشگاه",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/products/unsettled',
    name: 'store.products.unsettled',
    component: UnsettledProductsTable,
    meta: {
      title: "محصولات تسویه نشده",
      authRequired: true,
      isSeller: true,
    }
  },
  {
    path: '/store/settlement/payments',
    name: 'store.settlement.payments',
    component: StoreSettlementsTable,
    meta: {
      title: "پرداخت های تسویه حساب",
      authRequired: true,
      isSeller: true,
    }
  },









  {
    path: '/login',
    name: 'login',
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "صفحه ورود",
      guestRequired: true
    }
  },

];